import {
  Button,
  Divider,
  IconButton,
  Icons,
  useDialogInstance,
  ExternalLink,
  Stack,
  tokens,
} from '@cast/design-system';
import { openChat } from '@cast/utils';

import { TerraformSvg } from 'assets/svg';

import { useCluster } from '@cast/shared-cluster-context-data-access';

import { EXTERNAL_LINKS } from '@cast/constants';

type Props = {
  dismiss?: () => void;
};

export function DialogCloseActions(props: Props) {
  const { isTerraformManaged } = useCluster();
  const { destroy } = useDialogInstance();

  const onClose = props.dismiss || destroy;

  return (
    <Stack direction="row" alignItems="center" height={28}>
      {!isTerraformManaged && (
        <>
          <Button
            variant="text"
            component={ExternalLink}
            link={EXTERNAL_LINKS.castai_terraform}
            startIcon={<TerraformSvg />}
            noIcon
          >
            Terraform
          </Button>

          <Divider
            orientation="vertical"
            color={tokens.theme.border.structural.neutral}
            sx={{
              height: 22,
              mx: 8,
            }}
          />
        </>
      )}

      <IconButton variant="ghost" size="sm" onClick={openChat}>
        <Icons.Question />
      </IconButton>
      <IconButton
        variant="ghost"
        size="sm"
        onClick={onClose}
        testId="close-dialog"
      >
        <Icons.X />
      </IconButton>
    </Stack>
  );
}
